import React from "react";

// context
import { useBanners } from "frontend/context/BannersContext";

// components
import Banners from "core/Banners";

// component
const PromoBanners = () => {
    const {
        hideBanner,
        dismissBanner,
        bannerContent,
        bannerContentMobile,
        bannerKey
    } = useBanners();

    if (hideBanner) return null;

    return (
        <Banners
            bannerDismiss={dismissBanner}
            bannerKey={bannerKey}
            bannerContent={bannerContent}
            bannerContentMobile={bannerContentMobile}
            type={"info"} // make sure to edit this to correct banner type
        />
    );
};

export default PromoBanners;
